import React from 'react';
import classnames from 'classnames';
import { usePagination, DOTS } from './usePagination';
import * as rs from 'reactstrap';

const Pagination = props => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (<>
    <rs.Pagination size="sm" aria-label="pagination">
              <rs.PaginationItem disabled={ currentPage === 1}>
                <rs.PaginationLink onClick={onPrevious}>
                  {"<"}
                </rs.PaginationLink>
              </rs.PaginationItem>
              {paginationRange.map((pageNumber,i) => {
                if (pageNumber === DOTS) {
                  return <rs.PaginationItem key={i} disabled={ true}>
                            <rs.PaginationLink>
                            &#8230;
                            </rs.PaginationLink>
                          </rs.PaginationItem>
                  
                }
                return (
                  <rs.PaginationItem key={i} className={classnames({
                    active: pageNumber === currentPage
                  })}>
                            <rs.PaginationLink onClick={() => onPageChange(pageNumber)}
                             >
                            {pageNumber}
                            </rs.PaginationLink>
                          </rs.PaginationItem>
                );
                  })
                }

              <rs.PaginationItem disabled={ currentPage === lastPage}>
                <rs.PaginationLink onClick={onNext}>
                  {">"}
                </rs.PaginationLink>
              </rs.PaginationItem>
    </rs.Pagination>
   
  </>);
};

export default Pagination;
